import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { components } from 'react-select'

const HEADER_ROW = 'tw:flex tw:items-center tw:justify-between tw:gap-2 tw:w-full tw:px-3 tw:py-2'
  + ' tw:select-none'
const HEADER_ROW_TOGGLE = `${HEADER_ROW} tw:cursor-pointer`
const HEADER_NAME = 'tw:flex-1 tw:min-w-0 tw:truncate tw:text-sm tw:font-bold tw:text-gray-900'
const HEADER_SIDE = 'tw:flex tw:items-center tw:gap-2 tw:shrink-0 tw:text-xs tw:text-gray-500'

const ScopedSelectOption = props => {
  const { data, selectProps } = props
  const { onToggleGroup, collapsedGroups, locked } = selectProps
  const { groupKey } = data

  const handleMouseDown = useCallback(event => {
    event.preventDefault()
    event.stopPropagation()
    onToggleGroup(groupKey)
  }, [onToggleGroup, groupKey])

  if (!data.isGroupHeader)
    return <components.Option {...props}>{data.label}</components.Option>

  if (locked) {
    return (
      <div className={HEADER_ROW}>
        <span className={HEADER_NAME} title={data.label}>{data.label}</span>
        <span className={HEADER_SIDE}>{`${data.count}Q`}</span>
      </div>
    )
  }

  const collapsed = collapsedGroups.has(groupKey)
  const chevron = `fas fa-chevron-${collapsed ? 'down' : 'up'}`
  return (
    <div className={HEADER_ROW_TOGGLE} role="button" tabIndex={-1} onMouseDown={handleMouseDown}>
      <span className={HEADER_NAME} title={data.label}>{data.label}</span>
      <span className={HEADER_SIDE}>
        <span>{`${data.count}Q`}</span>
        <i aria-hidden="true" className={chevron} />
      </span>
    </div>
  )
}

ScopedSelectOption.propTypes = {
  data: PropTypes.shape({
    count: PropTypes.number,
    groupKey: PropTypes.string,
    isGroupHeader: PropTypes.bool,
    label: PropTypes.string
  }).isRequired,
  selectProps: PropTypes.shape({
    collapsedGroups: PropTypes.instanceOf(Set),
    locked: PropTypes.bool,
    onToggleGroup: PropTypes.func
  }).isRequired
}

export default ScopedSelectOption
